import { useCallback, useRef } from "react";

/**
 * Hidden Architect entry. Invoke the returned handler from any element's
 * onClick/onTouchStart (e.g. the anchor icon). Five taps inside
 * `windowMs` triggers `onUnlock()`.
 */
export default function useAnchorTapSecret({
  tapsRequired = 5,
  windowMs = 2000,
  onUnlock,
} = {}) {
  const tapsRef = useRef([]);

  const onTap = useCallback(() => {
    const now = Date.now();
    const recent = [...tapsRef.current, now].filter((t) => now - t <= windowMs);
    tapsRef.current = recent;
    if (recent.length >= tapsRequired) {
      tapsRef.current = [];
      onUnlock?.();
    }
  }, [tapsRequired, windowMs, onUnlock]);

  return onTap;
}
